import { useRouteMatch } from 'react-router';
import { Switch } from 'react-router-dom';

import { PrivateRoute } from '~/components/Auth';
import { OverlappingEmployment } from '~/scenes/PortalModules/OverlappingEmployment';

export const OverlappingEmploymentRouter = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <PrivateRoute
        path={path}
        render={() => {
          return <OverlappingEmployment />;
        }}
      />
    </Switch>
  );
};
